import { ReactElement, useState } from 'react';
import { Stack } from '@mui/material';
import {
  DateFromFilter,
  DateToFilter,
  PeriodFilter,
  RegionFilter,
} from '../../../../Components/ReportsWidget/Filters';
import ReportWidget from '../../../../Components/ReportsWidget/Widget';
import type { ClicksByReferrersResource } from '../../../../Entities/ClicksByReferrer';
import ClicksByReferrerDataTable from './ClicksByReferrerDataTable';
import ExportButton from './ExportButton';
import PreviewButton from './PreviewButton';

export default function ClicksByReferrerWidget(): ReactElement {
  const [hasPreview, setHasPreview] = useState(false);
  const [records, setRecords] = useState<ClicksByReferrersResource[]>([]);
  const [isPending, setIsPending] = useState(false);
  const [startDateLabel, setStartDateLabel] = useState('');
  const [endDateLabel, setEndDateLabel] = useState('');

  return (
    <Stack spacing={1}>
      <ReportWidget
        resource="clicks_by_referrers"
        filters={[RegionFilter, PeriodFilter, DateFromFilter, DateToFilter]}
        defaultValues={{ period: 'this_month' }}
        actions={
          <>
            <PreviewButton
              autoPreviewOnMount
              onPreviewStart={({ startDateLabel, endDateLabel }) => {
                setStartDateLabel(startDateLabel);
                setEndDateLabel(endDateLabel);
                setRecords([]);
                setHasPreview(true);
                setIsPending(true);
              }}
              onPreviewSuccess={(records) => {
                setRecords(records);
                setIsPending(false);
              }}
              onPreviewError={() => {
                setIsPending(false);
              }}
            />
            <ExportButton />
          </>
        }
      />
      {hasPreview && (
        <ClicksByReferrerDataTable
          data={records}
          isPending={isPending}
          startDateLabel={startDateLabel}
          endDateLabel={endDateLabel}
        />
      )}
    </Stack>
  );
}
